
<template>
  <div class="case">
<Nav></Nav>
      <div class="header">
          <div class="header_img">
              <img src="../assets/img/ater.png" alt="">
          </div>
      </div>
      <div class="swiper">

  <swiper :options="swiperOptions" class="swipers">
<swiperSlide  class="swiperSlides" v-for="(item,index) in list" :key="index">
    <div class="title_img">
           <ul>
               <li>
               <div class="matst">
                     <img :src="item.img" alt="">
                    <h4>{{item.desc_title}}</h4>
               </div>
               </li>
           </ul>
        </div>
           {{item.desc}}
</swiperSlide>
 <div class="swiper-button-prev" slot="button-prev"></div>
         <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
    <!-- <el-carousel height="300px" >
      <el-carousel-item v-for="(item,index) in list" :key="index">

      </el-carousel-item>
    </el-carousel> -->

      </div>
      <div class="main">
          <div class="w">
         <div class="title">
              <h3>真实有效的广告效果</h3>
          </div>

          <div class="tab">
              <div class="tab_title">
                  <ul>
                      <li  :class="{'tab_color':cuurId===item.id}" v-for=" (item,index) in titlelist" :key="index" @click="tabclick(item)" >
                        {{item.title}}
                      </li>
                  </ul>
              </div>
              <div class="tabl_main">
                     <ul>
                        <li v-for="(item,index) in desclistr" :key="index">
                          <div class="main_img">
                            <img v-lazy=" 'http://zyadmin.hundredzy.com' + item.coo_img" alt="">
                          </div>
                          <div class="main_desc">
                              <div class="main_left">
                            <p>{{item.coo_title}}</p>
                            <span>游戏类型：{{item.coo_background}}</span>
                          </div>
                          <div class="main_right">
                            <span>安装包：{{item.coo_size}}</span>
                            <i>平均成本：{{item.coo_cpa}}</i>
                          </div>
                          </div>
                      </li>
                  </ul>
              </div>
          </div>
         </div>
      </div>
<div class="w">
   <el-pagination
    background
   layout="prev, pager, next"
    :total="desclist.length"
    :page-size="pagesize"
    :current-page="pageindex"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
   >

</el-pagination>
</div>
      <Footer></Footer>
  </div>
</template>

<script>
import Footer from '../components/Footer'
import img1 from '../assets/img/onst.jpg'

import img2 from '../assets/img/lr.jpg'
import img3 from '../assets/img/fre.jpg'
import img4 from '../assets/img/cat.png'
import img5 from '../assets/img/lu.jpg'
import img6 from '../assets/img/tx.jpg'
import img7 from '../assets/img/aqy.jpg'
import img8 from '../assets/img/lan.jpg'
import img9 from '../assets/img/gai.jpg'

import { getCoo } from '../api/index'
import Nav from '../components/Nav'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  components: {
    Nav,
    Footer,
    swiper,
    swiperSlide
  },
  data () {
    return {
      swiperOptions: {
        autoplay: {
          delay: 3000,

          disableOnInteraction: false
        },
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: false
        },

        loop: true,
        effect: 'coverflow',
        slidesPerView: 2,
        // cubeEffect: {
        //   slideShadows: true,
        //   shadow: true,
        //   shadowOffset: 100,
        //   shadowScale: 0.6
        // },
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      pagesize: 5,
      pageindex: 1,
      list: [
        {
          id: 1,
          img: img1,
          desc_title: '畅游',
          desc: '  以优质流量为依托，精准的数据定向搭配绝佳的创意，使每款游戏的投放都有据可依。商务和运营根据每款游戏进行差异化投放策略定制，专业负责。'
        },
        {
          id: 2,
          img: img2,
          desc_title: '恋与制作人',
          desc: ' 寒诀广告平台平台能够根据热点给予创意和内容的输出，同时平台数据透明化也使段性的复盘更为高效，为投放提供了很好的引导作用，投放效果很成功。'
        },
        {
          id: 3,
          img: img3,
          desc_title: '大众点评',
          desc: ' 寒诀广告平台在营销推广中不仅为品牌提高声量，还针对我们的效果需求定制行之有效的信息流推广方案，充分展现了平台对于大数据驱动和精细化运营的优势。'
        },
        {
          id: 4,
          img: img4,
          desc_title: '汽车之家',
          desc: ' 寒诀广告平台平台以数据、创意、服务三大优势精准切入，解决用户“看、选、买、用、卖”的汽车使用需求，为我们带来十分可观的下载与转化。'
        },
        {
          id: 5,
          img: img5,
          desc_title: '驴妈妈',
          desc: ' 从消费升级的角度出发，在品牌与用户之间搭建了情感关联的互动推广。寒诀广告平台以精细的维度定向和创意优化，在拉新和转化上都获取了不错的效果。'
        },
        {
          id: 6,
          img: img6,
          desc_title: '腾讯游戏',
          desc: ' 寒诀广告平台具备很强的数据优化和文案创意能力，擅长总结经验和方法论，有效缩短游戏测试期，帮助我们快速推向市场，获取了大量优质用户。'
        },
        {
          id: 7,
          img: img7,
          desc_title: '爱奇艺游戏',
          desc: ' 寒诀广告平台优化师在投放过程中非常专业，流程对接标准顺畅，数据分析专业准确，合作起来非常愉快。'
        },
        {
          id: 8,
          img: img8,
          desc_title: '蓝港互动',
          desc: ' 寒诀广告平台游戏数据包定向，为快速锁定目标用户提供了极大的便利。优质的流量带来优质的回收，期待未来一起联手打造更多爆款游戏。'
        },
        {
          id: 9,
          img: img9,
          desc_title: '盖娅互娱',
          desc: ' 寒诀广告平台可根据产品类型，针对性提供定制数据包，让整个投放过程有条不紊，公开透明，效果看得见。'
        }

      ],
      cuurId: 0,
      titlelist: [
        {
          id: 0,
          title: '全部'
        },
        {
          id: 1,
          title: '宫斗'
        },
        {
          id: 2,
          title: '益智'
        },
        {
          id: 3,
          title: '二次元'
        },
        {
          id: 4,
          title: 'PRG'
        },
        {
          id: 5,
          title: 'MMO'
        },
        {
          id: 6,
          title: '模拟'
        },
        {
          id: 7,
          title: '其他'
        }
      ],
      desclist: []
    }
  },
  mounted () {
    // console.log(JSON.parse(this.$route.query.cast))
    this.getCooted()
  },
  computed: {
    desclistr () {
      return this.desclist.slice((this.pageindex - 1) * this.pagesize, this.pageindex * this.pagesize)
    }

  },
  watch: {
    cuurId (va) {
      this.getCooted()
    }
  },
  methods: {
    async getCooted () {
      let titles = this.titlelist[this.cuurId].title

      if (titles === '全部') {
        titles = 'all'
      }
      const res = await getCoo({

      }, {
        coo_type: titles
      })
      const { data } = res
      console.log(data)
      if (data.code === 0) {
        this.desclist = data.data
      }
    },
    tabclick (item) {
      this.cuurId = item.id
    },

    handleSizeChange () {

    },
    handleCurrentChange (va) {
      this.pageindex = va
    }
  }
}
</script>

<style lang="scss" scoped>
 .case  {
   .case_header {
     background-color: #fff;
     height: 90px;
     img {
       display: inline-block;

       width: 159px;
       height: 72px;
       cursor: pointer;
     }
   }
     .header {
       .header_img {
          img {
            height: 479px;
            background-color: pink;
          }
      }
     }
     .swiper {
        //  height: 363px;
         background-color: #f1f1f1;

           .swipers{
            //  padding-top: 84px;
            .swiperSlides {
              border:1px solid #DCDCDC;
              background-color: #fff;
                width: 570px !important;
                margin-left: 180px;
                margin-top: 100px;
              width: 570px;
              height: 180px;
             font-size: 18px;
             font-family: Microsoft YaHei;
             font-weight: 400;
             color: #666666;
             line-height: 34px;
             padding: 34px 38px 44px 30px;
             margin-bottom: 60px;
            //  &:nth-child(2) {
            //    margin-left: 120px;
            //  }
              .title_img {
             position: absolute;
             top: 0px;
            //  left: 400px;
             z-index: 4;

             ul {
                 li {
                    //  width: 88px;
                    //  height: 88px;
                    //  border-radius: 44px;
                    //  background-color: #fff;
                    //  margin-bottom: 23px;
                    //  border: 1px solid #ccc;
                    .matst {
                      display: flex;
                        img {
                        //  display: inline-block;
                        position: absolute;
                        top:-50px;
                         width: 60px;
                         height: 60px;
                        //  margin: 15px 15px 15px 15px;
                         border-radius: 30px;
                     }
                     h4 {
                       position: absolute;
                       top: -45px;
                       left: 53px;
                       width: 121px;
                       margin-left: 21px;
                       font-size: 21px;
                       margin-top: 3px;
                     }
                    }

                 }
             }
            }
          }

         .el-carousel__item:nth-child(2n) {
           background-color: #fff;
         }

         .el-carousel__item:nth-child(2n+1) {
           background-color: #fff;
         }
           }

       }
     .main {
        .w {
           .title {
               margin-top: 60px;
               margin-bottom: 60px;
               h3 {
                text-align: center;
                height: 26px;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #404040;
                line-height: 34px;
               }
           }
           .tab {

            .tab_title {
             ul {
               margin-left: 130px;
               display: flex;
               margin-bottom: 18px;
               .tab_color {
                 color: #3883F7;
               }
             li {
               font-size: 16px;
               font-family: Microsoft YaHei;
               font-weight: 400;
               color: #999999;
               line-height: 34px;
               margin-right: 90px;
               cursor: pointer;
                 }
               }
             }
             .tabl_main {
               ul {
                 li {
                   .main_img {
                     img {
                       height: 460px;
                     }
                   }
                   .main_desc {
                     margin-top: 28px;
                     margin-bottom: 60px;
                     display: flex;
                   .main_left {
                     display: flex;
                     font-size: 20px;
                     p {
                       margin-right: 59px;
                      color:  #333333;
                      font-family: Microsoft YaHei;
                      font-weight: bold;

                     }
                     span {
                       margin-right: 60px;
                         color: #999999;
                     }
                   }
                   .main_right {
                       font-size: 20px;
                      font-weight: 400;
                      color: #999999;
                      display: flex;
                     span {
                       margin-right: 60px;
                     }
                      i {
                     }
                    }
                   }
                 }
               }
             }
           }
        }
     }
     .el-pagination {
       margin-top: 94px;
       margin-left: 800px;
     }
 }
</style>
